import React, { useState, Fragment } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Circle, Check, ShieldCheck } from 'lucide-react';
const plans = [{
  id: 'base',
  title: 'Sistema Contable Base',
  price: '$19.990',
  originalPrice: '$39.990',
  checkoutUrl: 'https://laplumavirtual.com/cart/48093597139169:1',
  includes: ['Sistema de organización para contadores independientes', '6 bonos prácticos incluidos', '2 bonos premium'],
  description: 'Todo lo necesario para organizar tu estudio contable, gestionar clientes y controlar tus tareas profesionales.',
  shortDesc: 'Organizá tu estudio, gestioná clientes y controlá tus tareas profesionales.',
  badge: null,
  badgeColor: '',
  icon: '📦'
}, {
  id: 'profesional',
  title: 'Sistema Profesional',
  price: '$22.990',
  originalPrice: '$45.990',
  checkoutUrl: 'https://laplumavirtual.com/cart/48093597303009:1',
  includes: ['Incluye todo lo anterior +', 'Pack profesional de contratos contables'],
  description: 'Plantillas de contratos para formalizar servicios contables con tus clientes. Incluye modelos para: servicios contables • asesoría impositiva • honorarios mensuales • liquidación de sueldos • cláusulas de responsabilidad profesional.',
  shortDesc: 'Contratos listos para formalizar servicios contables, honorarios, sueldos y asesoría impositiva.',
  badge: 'MÁS VENDIDO',
  badgeColor: 'bg-amber-500',
  icon: '⭐'
}, {
  id: 'pro',
  title: 'Sistema Estudio PRO',
  price: '$24.990',
  originalPrice: '$49.990',
  checkoutUrl: 'https://laplumavirtual.com/cart/48093597270241:1',
  includes: ['Incluye todo lo anterior +', 'Pack profesional de presupuestos contables'],
  description: 'Plantillas para presentar y cotizar servicios contables de forma profesional. Incluye: cotización de servicios contables • propuestas profesionales para clientes • presentación de honorarios • presupuestos para asesoría impositiva.',
  shortDesc: 'Plantillas para cotizar, presentar propuestas y mostrar honorarios de forma profesional.',
  badge: null,
  badgeColor: '',
  icon: '🚀'
}, {
  id: 'elite',
  title: 'Sistema Contable Élite',
  price: '$29.990',
  originalPrice: '$59.990',
  checkoutUrl: 'https://laplumavirtual.com/cart/48093597237473:1',
  includes: ['Incluye todo lo anterior +', 'Pack de respuestas profesionales para clientes'],
  description: 'Biblioteca de mensajes profesionales listos para usar con clientes contables. Incluye respuestas para: consultas frecuentes • honorarios profesionales • recordatorios de vencimientos • pedidos de documentación • comunicación profesional por WhatsApp.',
  shortDesc: 'Mensajes profesionales listos para responder consultas, recordatorios y pedidos por WhatsApp.',
  badge: 'TODO INCLUIDO',
  badgeColor: 'bg-green-500',
  icon: '👑'
}];
export function PlanSelectionSection() {
  const [selectedPlan, setSelectedPlan] = useState('elite');
  return <section id="plan-selection" className="py-1.5 sm:py-20 px-2 sm:px-4 bg-[#0a111a] border-t border-slate-800/50" data-id="element-179">
      <div className="max-w-3xl mx-auto" data-id="element-180">
        {/* Header */}
        <div className="text-center mb-1 sm:mb-12" data-id="element-181">
          <h2 className="text-lg sm:text-3xl md:text-5xl font-extrabold text-white mb-0.5 sm:mb-4 uppercase tracking-tight" data-id="element-182">
            Elegí tu <span className="text-[#f1c40f]" data-id="element-183">sistema</span>:
          </h2>
          <p className="hidden sm:block text-slate-300 text-xs sm:text-base md:text-lg" data-id="element-184">
            Selecciona el plan que mejor se adapte a tu estudio contable.
          </p>
        </div>

        {/* Plan Cards */}
        <div className="space-y-0 sm:space-y-4 mb-1 sm:mb-10" data-id="element-185">
          {plans.map(plan => {
          const isSelected = selectedPlan === plan.id;
          return <motion.div key={plan.id} whileHover={{
            scale: 1.01
          }} whileTap={{
            scale: 0.99
          }} onClick={() => setSelectedPlan(plan.id)} className={`relative cursor-pointer rounded-lg sm:rounded-xl p-1 sm:p-5 md:p-6 transition-all duration-300 border sm:border-2 ${isSelected ? 'bg-slate-800/80 border-[#f1c40f] shadow-[0_0_20px_rgba(241,196,15,0.15)]' : 'bg-slate-900/60 border-slate-700/50 hover:border-slate-600'}`} data-id="element-186">
                <div className="flex items-start gap-2 sm:gap-4" data-id="element-187">
                  {/* Radio Button */}
                  <div className="mt-0.5 sm:mt-1 flex-shrink-0" data-id="element-188">
                    {isSelected ? <div className="w-4 h-4 sm:w-6 sm:h-6 rounded-full border-2 border-[#f1c40f] flex items-center justify-center" data-id="element-189">
                        <div className="w-2 h-2 sm:w-3 sm:h-3 bg-[#f1c40f] rounded-full" data-id="element-190" />
                      </div> : <div className="w-4 h-4 sm:w-6 sm:h-6 rounded-full border-2 border-slate-600" data-id="element-191" />}
                  </div>

                  {/* Content */}
                  <div className="flex-1 min-w-0" data-id="element-192">
                    <div className="flex items-center justify-between gap-2" data-id="element-193">
                      <div className="min-w-0" data-id="element-194">
                        <div className="flex items-center gap-1.5 sm:gap-2 flex-wrap" data-id="element-195">
                          <h3 className={`text-[11px] sm:text-lg md:text-xl font-bold uppercase whitespace-nowrap ${isSelected ? 'text-white' : 'text-slate-200'}`} data-id="element-196">
                            {plan.icon} {plan.title}
                          </h3>
                          {plan.badge && <span className={`${plan.badgeColor} text-white text-[7px] sm:text-[10px] font-extrabold px-1.5 sm:px-2 py-0.5 rounded uppercase tracking-wider`} data-id="element-197">
                              {plan.badge}
                            </span>}
                        </div>
                      </div>
                      <div className="text-right flex-shrink-0" data-id="element-198">
                        <div className="text-slate-500 line-through text-[9px] sm:text-sm font-medium" data-id="element-199">
                          {plan.originalPrice}
                        </div>
                        <div className={`text-base sm:text-2xl md:text-3xl font-extrabold ${isSelected ? 'text-[#f1c40f]' : 'text-white'}`} data-id="element-200">
                          {plan.price}
                        </div>
                      </div>
                    </div>

                    {/* Includes List - always visible */}
                    <div className="flex flex-wrap items-center gap-x-2 gap-y-0 sm:gap-y-1 mt-0.5 sm:mt-2 mb-0 sm:mb-3" data-id="element-201">
                      {plan.includes.map((item, i) => <span key={i} className="inline-flex items-center text-[10px] sm:text-sm text-slate-300 font-medium" data-id="element-202">
                          {item.startsWith('Incluye') ? <span className="text-slate-400 italic" data-id="element-203">
                              {item}
                            </span> : <>
                              <Check className="w-3 h-3 sm:w-3.5 sm:h-3.5 text-green-500 mr-0.5 sm:mr-1 flex-shrink-0" data-id="element-204" />
                              {item}
                            </>}
                        </span>)}
                    </div>

                    {/* Short description - mobile only */}
                    <p className="block sm:hidden text-[9px] text-slate-400 leading-tight mt-0" data-id="element-205">
                      {plan.shortDesc}
                    </p>
                    {/* Full description - desktop only */}
                    <div className="hidden sm:block text-xs md:text-sm text-slate-400 leading-relaxed bg-slate-900/50 p-3 rounded-lg border border-slate-800/50" data-id="element-206">
                      {plan.description}
                    </div>
                  </div>
                </div>
              </motion.div>;
        })}
        </div>

        {/* CTA Button */}
        <div className="flex flex-col items-center mb-4 sm:mb-12" data-id="element-207">
          <motion.a href={plans.find(p => p.id === selectedPlan)?.checkoutUrl || '#'} whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.97
        }} className="w-full max-w-xl bg-[#22C55E] hover:bg-[#16a34a] text-white font-extrabold text-xs sm:text-lg md:text-xl py-2 sm:py-4 md:py-5 px-4 sm:px-8 rounded-xl shadow-[0_0_25px_rgba(34,197,94,0.3)] hover:shadow-[0_0_35px_rgba(34,197,94,0.5)] transition-all duration-300 flex items-center justify-center gap-2 uppercase tracking-wide text-center" data-id="element-208">
            SÍ, QUIERO ACCEDER AL SISTEMA COMPLETO →
          </motion.a>
          <p className="text-slate-400 text-[9px] sm:text-xs md:text-sm mt-1 sm:mt-4 font-medium text-center" data-id="element-209">
            Podés pagar con tarjeta, transferencia o Mercado Pago.
          </p>
        </div>

        {/* Summary Card */}
        <div className="bg-slate-900/80 border border-slate-700/50 rounded-2xl p-6 md:p-8 space-y-6" data-id="element-210">
          {/* Block 1: El sistema completo incluye */}
          <div data-id="element-211">
            <h4 className="text-white font-bold text-sm md:text-base uppercase tracking-wider mb-4 border-b border-slate-700/50 pb-3" data-id="element-212">
              El sistema completo incluye:
            </h4>
            <div className="grid md:grid-cols-2 gap-x-8 gap-y-3" data-id="element-213">
              {['Tomo 1: Diagnóstico y estructura del estudio contable', 'Tomo 2: Sistema de organización de clientes', 'Tomo 3: Sistema de control de vencimientos fiscales', 'Tomo 4: Sistema de gestión del trabajo contable', 'Tomo 5: Sistema de gestión de documentación', 'Tomo 6: Control general del estudio y mejora continua'].map((item, i) => <div key={i} className="flex items-start gap-2.5" data-id="element-214">
                  <CheckCircle2 className="w-4.5 h-4.5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-215" />
                  <span className="text-slate-300 text-sm leading-snug" data-id="element-216">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>

          {/* Block 2: Bonos incluidos */}
          <div className="bg-slate-800/40 rounded-xl p-5 border border-slate-700/40" data-id="element-217">
            <h5 className="text-[#f1c40f] font-bold text-xs uppercase tracking-wider mb-4" data-id="element-218">
              + Bonos incluidos:
            </h5>
            <div className="grid md:grid-cols-2 gap-x-8 gap-y-3" data-id="element-219">
              {['Sistema de fichas de cliente contable', 'Sistema de checklist de control mensual contable', 'Sistema de seguimiento de tareas contables', 'Planilla de control de documentación de clientes', 'Sistema de control de vencimientos fiscales', 'Planilla de control general del estudio contable'].map((item, i) => <div key={i} className="flex items-start gap-2.5" data-id="element-220">
                  <CheckCircle2 className="w-4.5 h-4.5 text-[#f1c40f] flex-shrink-0 mt-0.5" data-id="element-221" />
                  <span className="text-slate-300 text-sm leading-snug" data-id="element-222">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>

          {/* Block 3: Bonos premium */}
          <div className="bg-slate-800/40 rounded-xl p-5 border border-slate-700/40" data-id="element-223">
            <h5 className="text-[#f1c40f] font-bold text-xs uppercase tracking-wider mb-4" data-id="element-224">
              + Bonos premium:
            </h5>
            <div className="grid md:grid-cols-2 gap-x-8 gap-y-3" data-id="element-225">
              {['Sistema profesional de planificación anual del estudio contable', 'Sistema avanzado de gestión de cartera de clientes contables'].map((item, i) => <div key={i} className="flex items-start gap-2.5" data-id="element-226">
                  <CheckCircle2 className="w-4.5 h-4.5 text-[#f1c40f] flex-shrink-0 mt-0.5" data-id="element-227" />
                  <span className="text-slate-300 text-sm leading-snug" data-id="element-228">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>

          {/* Block 4: Herramientas profesionales */}
          <div className="bg-[#f1c40f]/8 rounded-xl p-5 border border-[#f1c40f]/25" data-id="element-229">
            <h5 className="text-[#f1c40f] font-bold text-xs uppercase tracking-wider mb-4" data-id="element-230">
              + Herramientas profesionales:
            </h5>
            <div className="grid md:grid-cols-2 gap-x-8 gap-y-3" data-id="element-231">
              {['Pack de contratos profesionales para servicios contables', 'Pack profesional de presupuestos contables', 'Pack de respuestas profesionales para clientes contables'].map((item, i) => <div key={i} className="flex items-start gap-2.5" data-id="element-232">
                  <CheckCircle2 className="w-4.5 h-4.5 text-[#f1c40f] flex-shrink-0 mt-0.5" data-id="element-233" />
                  <span className="text-slate-300 text-sm leading-snug" data-id="element-234">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>

          {/* Trust badges */}
          <div className="flex items-center justify-center gap-4 pt-4 border-t border-slate-700/50 flex-wrap" data-id="element-235">
            {['Pago único', 'Acceso inmediato', 'Descarga ilimitada', 'Sin suscripciones'].map((item, i) => <span key={i} className="flex items-center gap-1.5 text-slate-400 text-xs font-medium" data-id="element-236">
                <Check className="w-3.5 h-3.5 text-green-500" data-id="element-237" />
                {item}
              </span>)}
          </div>
        </div>
      </div>
    </section>;
}